<script>
  import { uniq } from "lodash";
  import dayjs from "dayjs";
  import utc from "dayjs/plugin/utc";
  dayjs.extend(utc);

  export let players = ["geospiza"];
  export let is_valid = false;
  export let disabled = false;

  let display_keys = ["job", "level", "exp"];

  let timestamp;

  let player_data = {};

  let should_fetch = true;
  $: should_fetch &&
    players.map((name) => {
      fetch(
        // this proxies https://maplelegends.com/api/
        `https://us-west2-geospiza.cloudfunctions.net/character?name=${name}`
      ).then((resp) =>
        resp.json().then((row) => {
          player_data[name] = row;
          timestamp = row.timestamp;
          console.log(timestamp);
        })
      );
    }) &&
    (should_fetch = false);
  // this could be refactored into a component...
  $: validation_min_players = players.length > 0;
  $: validation_unique = uniq(players).length == players.length;
  $: validation_has_keys = players.every((player) =>
    Object.keys(player_data).includes(player)
  );
  $: validation_level = players.every((player) => {
    let data = player_data[player];
    if (!data) {
      return false;
    }
    return data.level >= 8;
  });
  $: is_valid =
    validation_min_players &&
    validation_unique &&
    validation_has_keys &&
    validation_level;
</script>

<div>
  <button
    on:click={() => (should_fetch = true)}
    disabled={disabled || should_fetch}
  >
    check status
  </button>
  <button
    on:click={() => (players = [...players, ""])}
    disabled={disabled || should_fetch}
  >
    add player
  </button>
</div>

<div>
  <p>
    {#if is_valid}
      Party is valid.
    {:else}
      Party is not valid, please fix the following issues:
      <ul>
        {#if !validation_min_players}
          <li>Must have at least one player</li>
        {/if}
        {#if !validation_unique}
          <li>Players are not unique</li>
        {/if}
        {#if !validation_has_keys}
          <li>The status check failed, run it again</li>
        {/if}
        {#if !validation_level}
          <li>All players must be above level 8</li>
        {/if}
      </ul>
    {/if}
    Last updated {dayjs.utc(timestamp).format()}.
  </p>
</div>

<div style="border:1px solid black;padding:1em">
  {#each players as name, i}
    <div>
      <button
        on:click={() => {
          players = [...players.filter((value) => value != name)];
        }}
        {disabled}>remove</button
      >
      <label>
        Player
        <input type="text" bind:value={players[i]} {disabled} />
      </label>
      {#if player_data[name]}
        {#each display_keys as key}
          <span>{player_data[name][key]} </span>
        {/each}
      {/if}
    </div>
  {/each}
</div>
